import axios from '../../library/modules/axios'
/** @type {import('axios').AxiosInstance} MaskClient */
const MaskClient = axios.maskBaseApi
export default MaskClient
